import React, { Component } from "react";
import {
  Link,
} from "react-router-dom";
 
class NotFound extends Component {
  render() {
    return (
      <div className="partial text-center">
        <div className="row">
          <div className="headerImage col-12 col-sm-6 offset-sm-3">
            <h2 className="subheader col-12">404</h2>
            <img src="./collage.jpg" alt="hero" />
          </div>
          <div className="rsvp-here col-12 text-center">
            <div className="intro col-10 offset-1">
              Whoa, you took a wrong turn somewhere...
            </div>
            <Link className="nav-link" to='/'>
              <div className="rsvp-button">TAKE ME HOME</div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
 
export default NotFound;